import { FileExcelOutlined } from "@ant-design/icons"
import { Button, Tooltip as AntdTooltip, TabsProps, Flex } from "antd"

import { CustomTabs } from "@/components/_Shared/CustomTabs/CustomTabs"

import { IAnalyticsPageDisplayUnit } from "@/types/IAnalytics"

interface AnalyticsDownloadProps {
  onExcelDownload: () => void
  isExcelLoading: boolean
}

export interface AnalyticsHeaderProps {
  displayUnits: IAnalyticsPageDisplayUnit[]
  activeUnit: IAnalyticsPageDisplayUnit
  filterComponent: JSX.Element
  onChangeTabs: ((tab: IAnalyticsPageDisplayUnit) => void)
  onExcelDownload?: AnalyticsDownloadProps
}

const AnalyticsHeader = (props: AnalyticsHeaderProps) => {
  const {
    displayUnits,
    activeUnit,
    filterComponent: component,
    onExcelDownload,
    onChangeTabs
  } = props

  const tabs: TabsProps = {
    defaultActiveKey: "0",
    items: displayUnits.map(x => ({ key: x.value, label: x.label }))
  }

  const tabsHandler = (key: string) => {
    onChangeTabs(displayUnits.find(x => x.value === key) ?? displayUnits[0])
  }

  return (
    <Flex justify="space-between" align="center">
      <CustomTabs
        type="card"
        {...tabs}
        activeKey={activeUnit.value}
        onChange={tabsHandler}
        style={{ marginBottom: "-17px" }}
      />
      <Flex gap="small">
        {
          onExcelDownload &&
          <AntdTooltip title="Выгрузить в Excel" style={{ marginLeft: "auto" }}>
            <Button
              type="primary"
              disabled={onExcelDownload.isExcelLoading}
              onClick={onExcelDownload.onExcelDownload}
              icon={<FileExcelOutlined />}
            />
          </AntdTooltip>
        }
        {
          component
        }
      </Flex>
    </Flex>
  )
}

export default AnalyticsHeader
